import React from 'react';
import { FaCheckCircle, FaExclamationTriangle, FaTimes } from 'react-icons/fa';
import { Badge, Spinner } from './Primitives';
import {
  isTerminalOperation,
  isOperationSuccess,
  operationStatusMeta,
} from '../utils/constants';
import { actionMeta } from '../utils/constants';

/**
 * Feedback compatto sullo stato di un'operazione in corso o conclusa su una VM.
 * Mostra badge di stato, messaggio comprensibile (mai output SSH grezzo) e, a
 * conclusione, un pulsante per rimuovere l'esito.
 */
export default function OperationStatus({ op, onDismiss, compact = false }) {
  if (!op) return null;
  const meta = operationStatusMeta(op.status);
  const terminal = isTerminalOperation(op.status);
  const success = isOperationSuccess(op.status);
  const aMeta = actionMeta(op.action);

  return (
    <div
      className={`flex items-start gap-2 rounded-lg border px-2.5 py-2 text-xs ${
        success
          ? 'border-emerald-200 bg-emerald-50 dark:border-emerald-900/50 dark:bg-emerald-950/30'
          : terminal
          ? 'border-red-200 bg-red-50 dark:border-red-900/50 dark:bg-red-950/30'
          : 'border-sky-200 bg-sky-50 dark:border-sky-900/50 dark:bg-sky-950/30'
      }`}
      role="status"
      aria-live="polite"
    >
      <span className="mt-0.5 shrink-0">
        {!terminal && <Spinner className="h-3.5 w-3.5" />}
        {terminal && success && (
          <FaCheckCircle className="text-emerald-500" size={14} aria-hidden="true" />
        )}
        {terminal && !success && (
          <FaExclamationTriangle className="text-red-500" size={14} aria-hidden="true" />
        )}
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-1.5">
          {aMeta && (
            <span className="font-medium text-gray-700 dark:text-gray-200">
              {aMeta.verb}
            </span>
          )}
          <Badge className={meta.style}>{meta.label}</Badge>
        </div>
        {op.error && (
          <p className="mt-1 text-red-600 dark:text-red-400">{op.error}</p>
        )}
        {!op.error && terminal && success && (
          <p className="mt-1 text-emerald-700 dark:text-emerald-300">
            Operazione completata e verificata.
          </p>
        )}
        {!terminal && !compact && (
          <p className="mt-1 text-gray-500 dark:text-gray-400">
            Verifica in corso… l’azione non è conclusa finché lo stato non è
            confermato.
          </p>
        )}
      </div>
      {terminal && onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="shrink-0 rounded p-1 text-gray-400 hover:text-gray-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary dark:hover:text-gray-200"
          aria-label="Chiudi messaggio operazione"
        >
          <FaTimes size={12} aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
